"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentDialogReducer = exports.setContentDialogState = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    isOpen: false,
    header: "",
    contentMaxWidth: "max-w-3xl",
    hideCloseButton: false,
    isDismissable: false,
};
var modalSlice = (0, toolkit_1.createSlice)({
    name: "contentDialog",
    initialState: initialState,
    reducers: {
        setContentDialogState: function (state, action) {
            var _a = action.payload, isOpen = _a.isOpen, header = _a.header, contentMaxWidth = _a.contentMaxWidth, hideCloseButton = _a.hideCloseButton, isDismissable = _a.isDismissable;
            state.isOpen = isOpen;
            state.header = header || "";
            state.contentMaxWidth = contentMaxWidth;
            state.hideCloseButton = hideCloseButton;
            state.isDismissable = isDismissable;
        },
    },
});
exports.setContentDialogState = modalSlice.actions.setContentDialogState;
exports.contentDialogReducer = modalSlice.reducer;
